import { render } from "./PaywallCTA.vue?vue&type=template&id=e57a4b80&scoped=true"
const script = {}

import "./PaywallCTA.vue?vue&type=style&index=0&id=e57a4b80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e57a4b80"]])

export default __exports__